function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("g", {
  id: "_1985952041008"
}, /*#__PURE__*/React.createElement("path", {
  d: "M458 3c-448,0 -458,-39 -458,159l0 390c0,42 -9,119 65,133 31,5 511,1 586,1 51,0 152,6 197,-1 26,-4 48,-22 58,-39 14,-25 10,-59 10,-90l0 -390c0,-200 -3,-163 -458,-163l0 0zm-95 476l-21 0 0 -136c0,-33 6,-30 -47,-30 -19,0 -14,14 -14,30l0 136 -21 0 0 -73c-1,-15 -19,-11 -47,-11 -18,0 -14,11 -14,34 0,17 0,33 0,49 -8,1 -12,1 -21,1l0 -111c0,-18 -14,-14 -47,-14 -15,0 -15,6 -14,19l0 106c-9,0 -19,-1 -21,7 -2,10 5,13 13,13l323 0c18,0 18,-20 0,-20l-8 0 0 -214c0,-18 -14,-13 -47,-13 -19,0 -14,12 -14,45l0 182 0 0zm1 -290c-6,6 -15,12 -23,17 -20,15 -6,7 -26,5 -12,-1 -22,4 -28,11 -9,11 -5,19 -4,34l-40 39c-28,-5 -20,0 -36,6l-29 -14c-2,-9 0,-26 -20,-33 -32,-12 -57,30 -29,53 18,14 35,0 40,-2l29 15c4,12 0,16 10,25 16,15 39,10 48,-6 7,-12 3,-17 2,-30l39 -39c14,2 23,5 34,-5 9,-8 12,-16 10,-32 6,-6 20,-16 29,-23 5,-3 5,-5 10,-3 20,9 39,-2 43,-20 11,-45 -66,-55 -59,2l0 0zm328 11c-5,0 -9,4 -9,9l0 125c0,5 4,9 9,9l124 0c5,0 9,-4 9,-9 0,-73 -60,-134 -133,-134zm17 283l-43 -115 0 -123c0,-5 -4,-9 -9,-9 -177,0 -175,266 0,266 16,0 32,-2 46,-8 5,-2 7,-7 6,-11l0 0zm107 -123l-124 0c-3,0 -5,2 -7,4 -2,2 -2,6 -1,8l43 117c1,2 3,4 5,5 2,1 5,1 7,0 51,-19 86,-70 86,-125 0,-5 -4,-9 -9,-9l0 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M320 804c-23,1 -49,-3 -57,15 -12,27 10,39 34,39l320 0c26,0 46,-10 38,-36 -7,-21 -34,-16 -58,-18 -27,-81 58,-64 -257,-64 -15,0 -15,49 -20,64z"
})));

var SvgMobilebase = function SvgMobilebase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 917 858",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobilebase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobilebase.ba2edd7f.svg";
export { ForwardRef as ReactComponent };